import { useTranslation } from "react-i18next";
import { Flame } from "lucide-react";

const hoursLeft = (iso) => Math.max(1, Math.ceil((new Date(iso) - Date.now()) / 3600000));

export const CandleList = ({ data, name }) => {
  const { t } = useTranslation();
  return (
    <section className="mt-20" aria-labelledby="candles-title" data-testid="memorial-candles">
      <h2 id="candles-title" className="font-heading text-2xl sm:text-3xl flex items-center gap-3">
        <Flame size={22} className="text-[var(--gold)]" /> {t("candle.recent")}
        {data.count > 0 && <span className="text-base font-body text-[hsl(var(--muted-foreground))]" data-testid="candles-count">· {t("candle.count", { count: data.count })}</span>}
      </h2>
      {data.items.length === 0 ? (
        <p className="text-[hsl(var(--muted-foreground))] mt-4" data-testid="candles-empty">{t("candle.none")}</p>
      ) : (
        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mt-8">
          {data.items.map((c) => (
            <li key={c.id} className={`candle-card rounded-2xl border p-4 flex gap-3 items-start ${c.kind === "anniversary" ? "border-[var(--gold)] sm:col-span-2 lg:col-span-3" : ""}`} data-testid={`candle-item-${c.id}`}>
              <span className="candle-flame mt-1" aria-hidden="true" />
              <div className="min-w-0">
                {c.kind === "anniversary" ? (
                  <>
                    <p className="font-heading text-lg italic" data-testid="candle-anniversary-message">{t("candle.anniversary", { count: c.years, name })}</p>
                    <p className="text-xs font-semibold mt-1 text-[var(--gold)]">{t("candle.signature", { brand: t("brand.name") })}</p>
                  </>
                ) : (
                  <p className="text-sm italic break-words" dir="auto">{c.message || t("candle.anonymous")}</p>
                )}
                <p className="text-xs text-[hsl(var(--muted-foreground))] mt-1">{t("candle.remaining", { hours: hoursLeft(c.expires_at) })}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
};
